import { updateUser } from "./userAction";

export const valueOrdersFilter = (obj) => (dispatch) => {
  dispatch({
    type: "UPDATE_ORDERS_FILTERS",
    payload: obj,
  });
};

export const valueMultiOrdersFilter = (obj) => (dispatch) => {
  dispatch({
    type: "UPDATE_MULTI_ORDERS_FILTERS",
    payload: obj,
  });
};

export const resetOrdersFilter = () => (dispatch) => {
  dispatch({
    type: "RESET_ORDERS_FILTERS",
  });
};

export const setUserSuppliers = (data) => (dispatch) => {
  dispatch({
    type: "SET_USER_SUPPLIERS",
    payload: data,
  });
};

export const onFilterUpdateWithUser =
  (value, column, filter_name) => async (dispatch, getState) => {
    try {
      const user_id = getState().auth.user.id;
      const isSpecialCase =
        column === "user_categories" && filter_name === "categoryFilter";

      const finalValue = isSpecialCase
        ? Array.isArray(value)
          ? value.map((item) => item.id)
          : value
        : value;

      let body = {
        user: {
          [column]: finalValue,
        },
      };

      if (
        [
          "user_statuses",
          "user_categories",
          "user_table",
          "user_suppliers",
        ].includes(column)
      ) {
        body = {
          user: {
            user_setting_attributes: {
              [column]: finalValue,
            },
          },
        };
      }

      await dispatch(updateUser(user_id, body));
      await dispatch(valueOrdersFilter({ name: filter_name, value }));
    } catch (err) {
      console.log("ERROR: ", err);
    }
  };

export const onFilterUpdateWithMainUser =
  (value, column, filter_name) => async (dispatch, getState) => {
    try {
      const user_id = getState().auth.user.id;

      const transformedValue =
        column === "user_categories"
          ? Array.isArray(value)
            ? value.map((item) =>
                Array.isArray(item) ? item[0] : item.id || item
              )
            : value
          : value;

      let body = {
        user: {
          [column]: transformedValue,
        },
      };

      if (
        [
          "user_statuses",
          "user_categories",
          "user_table",
          "user_suppliers",
        ].includes(column)
      ) {
        body = {
          user: {
            user_setting_attributes: {
              [column]: transformedValue,
            },
          },
        };
      }

      await dispatch(updateUser(user_id, body));
      await dispatch(valueOrdersFilter({ name: filter_name, value }));
    } catch (err) {
      console.log("ERROR: ", err);
    }
  };
